import { jsx } from "react/jsx-runtime";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const DextTextInputWUT = (props) => {
  const fieldType = FIELD_TYPES.DEXT_TEXT_INPUT;
  return /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, fieldType });
};
export {
  DextTextInputWUT
};
//# sourceMappingURL=dext-text-input-wut.js.map
